import React, { useEffect, useState } from "react";

import { AppLoader } from "../../common/components/AppLoader";
import { useSprintFetch } from "../data-access/useSprintFetch";
import { AppConfig, AppConfigContext } from "./Configuration";

type ConfigurationProviderProps = React.PropsWithChildren<unknown>;

export const ConfigurationProvider: React.FunctionComponent<ConfigurationProviderProps> = ({
    children
}: ConfigurationProviderProps) => {
    const [configuration, setConfiguration] = useState<AppConfig>();
    const sprintFetch = useSprintFetch({ isPublic: false });

    useEffect(() => {
        sprintFetch.httpGet<AppConfig>(`${process.env.PUBLIC_URL}/api/configuration/private`).then((configJson) => {
            setConfiguration(configJson);
        });
    }, []);

    if (configuration) {
        return <AppConfigContext.Provider value={configuration}>{children}</AppConfigContext.Provider>;
    }

    return <AppLoader message="Loading configuration..." />;
};
